module.exports = __webpack_public_path__ + "assets/just-eat-39b009.svg";